import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./views/Home";
import Layout from "./components/Layout/Layout";
import GettingStarted from "./views/GettingStarted/GettingStarted";
import Article from "./views/GettingStarted/GettingStartedArticle";
import Troubleshooting from "./views/Troubleshooting/Troubleshooting";
import TroubleshootingArticle from "./views/Troubleshooting/TroubleshootingArticle";
import AccountManagement from "./views/AccountManagement/AccountManagement";
import AccountManagementArticle from "./views/AccountManagement/AccountManagementArticle";
import BillingInformation from "./views/BillingInformation/BillingInformation";
import BillingInformationArticle from "./views/BillingInformation/BillingInformationArticle";
import FeaturedTopics from "./views/FeaturedTopics/FeaturedTopics";
import FeaturedTopicsTabs from "./views/FeaturedTopics/Articles/Tabs";
import FeaturedTopicsNavigate from "./views/FeaturedTopics/Articles/Navigate";
import FeaturedTopicsAcronyms from "./views/FeaturedTopics/Articles/Acronyms";
import Guides from "./views/Guides/Guides";
import GuidesBasics from "./views/Guides/Articles/Basics";
import GuidesPaper from "./views/Guides/Articles/Paper";
import GuidesLevel2 from "./views/Guides/Articles/Level2";
import NotFound from "./views/Error/NotFound";
import GuidesModeration from "./views/Guides/Articles/Moderation";
import MembersAdvisoryBoard from "./views/MembersAdvisoryBoard/MembersAdvisoryBoard";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/" element={<App />} />
          <Route path="/getting-started" element={<GettingStarted />} />
          <Route path="/getting-started/:title" element={<Article />} />
          <Route path="/troubleshooting" element={<Troubleshooting />} />
          <Route
            path="/troubleshooting/:title"
            element={<TroubleshootingArticle />}
          />
          <Route path="/account-management" element={<AccountManagement />} />
          <Route
            path="/account-management/:title"
            element={<AccountManagementArticle />}
          />
          <Route path="/billing-information" element={<BillingInformation />} />
          <Route
            path="/billing-information/:title"
            element={<BillingInformationArticle />}
          />
          <Route path="/featured-topics" element={<FeaturedTopics />} />
          <Route
            path="/featured-topics/tabs"
            element={<FeaturedTopicsTabs />}
          />

          <Route
            path="/featured-topics/navigate"
            element={<FeaturedTopicsNavigate />}
          />
          <Route
            path="/featured-topics/acronyms"
            element={<FeaturedTopicsAcronyms />}
          />
          <Route path="guides" element={<Guides />} />
          <Route path="/guides/basics" element={<GuidesBasics />} />
          <Route path="/guides/paper" element={<GuidesPaper />} />
          <Route path="/guides/level2" element={<GuidesLevel2 />} />
          <Route path="/guides/moderation" element={<GuidesModeration />} />
        </Route>
        <Route
          path="/member-advisory-board"
          element={<MembersAdvisoryBoard />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
